import "../../../../chunk-D57E6H3M.mjs";

// src/components/composite/Timeline/shared/AddToCartStatus.tsx
import { addToCartAriaLabel } from "./useAddToCartState.mjs";
import { jsx } from "react/jsx-runtime";
function AddToCartStatus({ outcome, t }) {
  return /* @__PURE__ */ jsx("span", { role: "status", className: "buyscout-add-to-cart-status", children: outcome ? addToCartAriaLabel(t, outcome.state, outcome.product.title) : "" });
}
AddToCartStatus.displayName = "AddToCartStatus";
export {
  AddToCartStatus
};
//# sourceMappingURL=AddToCartStatus.mjs.map